import { anyArray, dataMember, required } from 'santee-dcts';
import { deserializers } from '../../core/deserializers';
import { Moment } from 'moment';

export class ActivityReport {
    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public postedDateTime: Moment;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public accessDateTime: Moment;
}

export class ActivityReportsReadModel {
    @dataMember()
    @required()
    @anyArray()
    public activityReports: ActivityReport[];
}

